import type { WidgetListFilters } from '../api/widget-definitions.api';

/* eslint-disable i18next/no-literal-string -- cache key segments, not user-facing */
export const widgetQueryKeys = {
  all: ['widget-definitions'] as const,
  list: (filters: WidgetListFilters = {}) => [...widgetQueryKeys.all, 'list', filters] as const,
  detail: (id: string) => [...widgetQueryKeys.all, 'detail', id] as const,
  versions: (id: string) => [...widgetQueryKeys.all, 'versions', id] as const,
  checks: (id: string) => [...widgetQueryKeys.all, 'check', id] as const,
  check: (id: string, draftRevision: number) =>
    [...widgetQueryKeys.checks(id), draftRevision] as const,
  thumbnail: (id: string) => [...widgetQueryKeys.all, 'thumbnail', id] as const,
};
/* eslint-enable i18next/no-literal-string */
